@if (showScreen()) {
  <div popup *renderInAppToolbar>
    <mat-card>
      <mat-card-header>
        <mat-card-title>Session Timeout</mat-card-title>
      </mat-card-header>
      <mat-card-content> Your login has timed out due to inactivity </mat-card-content>

      <mat-card-actions>
        @if (!options.hideLogin()) {
          <button mat-flat-button (click)="login()">Log back in</button>
        }
        @if (!options.hideContinueWithoutLogin()) {
          <button mat-stroked-button (click)="continue()">Continue without logging in</button>
        }
      </mat-card-actions>
    </mat-card>
  </div>
}
